import React, { useState, useEffect, useContext } from "react";
import { Segment } from "semantic-ui-react";
import styled from "styled-components";
import { useQuery, useMutation } from "@apollo/client";

import MarketPlaceHeader from "../components/MarketPlaceHeader";
import MarketPlaceSearch from "../components/MarketPlaceSearch";
import MarketPlaceFeatured from "../components/MarketPlaceFeatured";
import { GApageView } from "../..";
import { Context } from "../../../context/globalContext";
import WriteReviewModal from "../../genericComponents/WriteReviewModal";
import {
  initialState,
  reducer,
  asyncChatActionHandlers,
} from "../stateManagement";
import { useReducerAsync } from "use-reducer-async";
import { GET_LOCKER, RESOURCES } from "../../../helpers/graphqlQueries";
import { ADD_RESOURCE_TO_LOCKER, DELETE_FROM_LOCKER } from "../../../helpers/graphqlMutations";

const MarketPlaceContainer = styled(Segment.Group)`
  margin: 0 !important;
  border: none;
`;

export default function MarketPlaceScreen(){
  const [searchField, setSearchField] = useState("");
  const [activeCategory, setActiveCategory] = useState("");
  const [offset, setOffset] = useState(0);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [writeReviewId, setwriteReviewId] = useState("");
  const [writeReviewName, setwriteReviewName] = useState("");

  const [state, dispatch] = useReducerAsync(
    reducer,
    initialState,
    asyncChatActionHandlers
  );

  const {
    state: { user },
  } = useContext(Context);
  const email = user.email;

  // gql
  const {
    loading: loadingLocker,
    data: lockerResponse,
    refetch: refecthLocker,
  } = useQuery(GET_LOCKER, { variables: { email } });
  const {
    data: resourcesResponse,
    loading: loadingResources,
    refetch: refetchResources,
  } = useQuery(RESOURCES);

  const [addToLocker] = useMutation(ADD_RESOURCE_TO_LOCKER);
  const [removeFromLocker] = useMutation(DELETE_FROM_LOCKER);

  // handlers
  const getResourcesOnLocker = (resources, resourcesFromLocker) => {
    return resources.map((resource) => {
      const index = resourcesFromLocker.findIndex(
        (lockerResource) => lockerResource.resource_id === resource.id
      );
      if (index > -1) return { ...resource, onLocker: true };
      return resource;
    });
  };

  const handleLockerButtonPress = async (resourceId, onLocker) => {
    try {
      if (onLocker) {
        await removeFromLocker({
          variables: {
            user_id: email,
            resource_id: resourceId,
          },
        });
        dispatch({
          type: "setOnLocker",
          resource_id: resourceId,
          listProducts: state.listProducts,
          listProductsFiltered: state.listProductsFiltered,
          onLocker: false,
        });
      } else {
        await addToLocker({
          variables: {
            user_id: email,
            resource_id: resourceId,
          },
        });
        dispatch({
          type: "setOnLocker",
          resource_id: resourceId,
          listProducts: state.listProducts,
          listProductsFiltered: state.listProductsFiltered,
          onLocker: true,
        });
      }
      //console.log("refresh")
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleSearch = () => {

    dispatch({
      type: "setFilterListBySearch",
      searchField,
      listProducts: state.listProducts,
    });
    setActiveCategory("");

  };

  const handleFilterByCategory = (categoryId) => {
    setActiveCategory(categoryId);
    setSearchField("");
    dispatch({
      type: "setFilterListByCategory",
      categoryId,
      listProducts: state.listProducts,
    });
  };

  const handleClearFilters = () => {
    dispatch({
      type: "clearFilterList",
      payload: state.listProducts,
    });

    setSearchField("");
    setActiveCategory("");
  };

  const initialList = () => {
    const payload = getResourcesOnLocker(
      [...resourcesResponse.resources],
      lockerResponse.resources_locker
    );
    dispatch({
      type: "setProductList",
      payload,
    });
  };

  useEffect(() => {
    if (resourcesResponse && lockerResponse) {
      initialList();
    }
  }, [resourcesResponse, lockerResponse]);

  useEffect(() => {
    GApageView("Marketplace");
  }, []);

  // useEffect(() => {
  //   refetchResources({ limit: 10, offset });
  // }, [offset]);

  const handleFilterResourcesByName = () => {
    dispatch({
      type: "orderFilterName",
      listProductsFiltered: state.listProductsFiltered,
    });
  };

  const handleFilterResourcesByPrice = () => {
    dispatch({
      type: "orderFilterPrice",
      listProductsFiltered: state.listProductsFiltered,
    });
  };

  const handleWriteReview = (idResource, resourceName) => {
    setwriteReviewId(idResource);
    setwriteReviewName(resourceName);
    setModalVisibility(true);

  };


  return (
    <>
      <MarketPlaceContainer>
        <MarketPlaceHeader />
        <MarketPlaceSearch
          searchField={searchField}
          setSearchField={setSearchField}
          handleSearch={handleSearch}
          handleFilterByCategory={handleFilterByCategory}
          handleClearFilters={handleClearFilters}
          activeCategory={activeCategory}
        />
        <MarketPlaceFeatured
          handleWriteReview={handleWriteReview}
          onLockerButtonPress={handleLockerButtonPress}
          resources={state.listProductsFiltered}
          loading={loadingResources || loadingLocker}
          handleLoadMore={() => setOffset((prevOffset) => prevOffset + 10)}
          handleFilterResourcesByPrice={handleFilterResourcesByPrice}
          handleFilterResourcesByName={handleFilterResourcesByName}
        />
      </MarketPlaceContainer>

      {modalVisibility && (
        <WriteReviewModal
          isShow={modalVisibility}
          onClose={() => setModalVisibility(false)}
          idResource={writeReviewId}
          resourceName={writeReviewName}
        />
      )}

    </>
  );
};